module.exports = __webpack_public_path__ + "static/media/paredes_vivas_5.8d8f7635.jpg";